<style lang="scss" scoped>
.returnScence {
  pointer-events: all;
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 135px;
  cursor: pointer;
  background-image: url("../../assets/pagesImg/returnBtn-normal.png");

  &:hover {
    background-image: url("../../assets/pagesImg/returnBtn-active.png");
  }
}
</style>

<template>
  <div class="returnScence" @click="returnScence"></div>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";
export default {
  name: "custom-return",
  methods: {
    returnScence() {
      bus.emit("back");
    },
  },
};
</script>
